// extracted by mini-css-extract-plugin
module.exports = {"ResponsiveSpacer":"ResponsiveSpacer_ResponsiveSpacer__bK4E9","small":"ResponsiveSpacer_small___jNAQ"};